import React from "react";
// history back 記録、state 保持
import { createBrowserHistory, createMemoryHistory } from 'history';
// history back 記録、state 保持
const history = createBrowserHistory();
// const history = createMemoryHistory();
export default history;
